import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { IconButton } from "@material-tailwind/react";
import api from "../api/api";
import { logo } from "../assets/images";

const PasswordReset = () => {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [checkPwd1, setCheckPawd1] = useState(false);
  const [checkPwd2, setCheckPawd2] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();


  // const resetToken = searchParams.get('reset');
  const secondParam = searchParams.get('fct');

  // console.log("resetToken", resetToken);
  // console.log("secondParam", secondParam);

  const isValidate = () => {
    let isProceed = true;
    let errorMessage = "";

    if (formData.password !== formData.confirmPassword) {
      isProceed = false;
      errorMessage = "Les mots de passe ne correspondent pas.";
    }

    if (!isProceed) toast.warning(errorMessage);
    return isProceed;
  };

  const handleCheck = (checker) => {
    if (checker === "pwd") {
      setCheckPawd1(!checkPwd1);
    }
    if (checker === "cpwd") {
      setCheckPawd2(!checkPwd2);
    }
  };
  const onSubmit = async (e) => {
    // console.log("e", formData);
    e.preventDefault();

    if (isValidate()) {
      try {
        const response = await api.post("/auths/rest_password", {
          password: formData.confirmPassword.trim(),
          id: secondParam
        });

        if (response.status === 200) {
          toast.success(`${response.data.message}`);
          setTimeout(() => {
            navigate("/login");
          }, 1500);

        } else {
          toast.error(`${response.data.message}`);
        }

      } catch (err) {

        toast.error(`${err.message}`);
      }
    }
  };

  // useEffect(() => {
  //   if (!secondParam) {
  //     navigate('/')
  //   }

  // }, [secondParam])

  return (
    <div className=" h-screen">
      <Link to="/" className="btn btn-circle m-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <path d="m12.718 4.707-1.413-1.415L2.585 12l8.72 8.707 1.413-1.415L6.417 13H20v-2H6.416l6.302-6.293z" />
        </svg>
      </Link>
      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="200"
        className="p-4"
      >
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
              className="mx-auto h-20 rounded-lg w-auto"
              src={logo}
              alt="Moide Ferme"
            />
            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Réinitialisation de mot de passe
            </h2>
          </div>
        </div>

        <div className=" sm:mx-auto sm:w-full sm:max-w-lg bg-white p-8">
          <form className="" onSubmit={onSubmit}>
            <label className="form-control  w-full ">
              {/* Password */}
              <label className="form-control w-full my-5">
                <span className="label-text">Mot de passe</span>
                <div className="flex items-center gap-2 input input-bordered w-full">
                  <input
                    type={checkPwd1 ? "text" : "password"}
                    placeholder="Mot de passe"
                    className="grow text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    required
                  />
                  <IconButton onClick={() => handleCheck("pwd")} variant="text">
                    {checkPwd1 ? "👁" : "🙈"}
                  </IconButton>
                </div>
              </label>

              {/* Confirm Password */}
              <label className="form-control w-full">
                <span className="label-text">Confirmation mot de passe</span>
                <div className="flex items-center gap-2 input input-bordered w-full">
                  <input
                    type={checkPwd2 ? "text" : "password"}
                    placeholder="Confirmer le mot de passe"
                    className="grow text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                    required
                  />
                  <IconButton onClick={() => handleCheck("cpwd")} variant="text">
                    {checkPwd2 ? "👁" : "🙈"}
                  </IconButton>
                </div>
              </label>

              {/* Submit Button */}
              <div className="sm:col-span-2 flex justify-center mt-10 mb-5">
                <button
                  type="submit"
                  className="w-7/12 mx-auto bg-black text-white p-3  rounded-md hover:bg-gray-800"
                >
                  Confirmer
                </button>
              </div>

            </label>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
